import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-783bd842"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputSet = _resolveComponent("InputSet");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass(['form-container', _ctx.blockWidthClass]),
        onObserveNodeVisibility: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createElementVNode("fieldset", null, [
                    _hoisted_1,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputSets, (inputSet, index) => {
                        return (_openBlock(), _createBlock(_component_InputSet, {
                            key: index,
                            class: _normalizeClass(['input-set', _ctx.blockWidthClass]),
                            "data-external": `view-form-input-row-${index}`,
                            "input-set": inputSet,
                            context: _ctx.context,
                            "focused-required-id": _ctx.focusedRequiredId,
                            "merge-values": _ctx.mergeValues,
                            fields: _ctx.node.fields,
                            sender: _ctx.sender,
                            recipient: _ctx.recipient,
                            "recipient-input": _ctx.recipientInput,
                            "is-mobile": _ctx.isMobile,
                            "is-pdf-viewer": _ctx.isPdfViewer,
                            "updating-inputs": _ctx.updatingInputs,
                            "failed-input-updates": _ctx.failedInputUpdates,
                            onUpdateValue: _cache[0] || (_cache[0] = ($event) => (_ctx.updateInputValue($event.inputId, $event.value))),
                            onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                        }, null, 8, ["class", "data-external", "input-set", "context", "focused-required-id", "merge-values", "fields", "sender", "recipient", "recipient-input", "is-mobile", "is-pdf-viewer", "updating-inputs", "failed-input-updates"]));
                    }), 128))
                ])
            ], 32)
        ]),
        _: 1
    }, 8, ["class"]));
}
